// PAYMENT INFORMATION
export const POST_PAYMENT_INFORMATION = 'POST_PAYMENT_INFORMATION';
export const POST_PAYMENT_INFORMATION_SUCCESS = 'POST_PAYMENT_INFORMATION_SUCCESS';
export const POST_PAYMENT_INFORMATION_FAILURE = 'POST_PAYMENT_INFORMATION_FAILURE';